import React, { useState } from 'react';
import i18next from 'core/i18n';

import {
  PhaseSection,
  PhaseSectionProps
} from 'features/brazil-grower/components/BrazilGrowerFinance/shared/PhaseSection';
import { NotesModal, NotesModalProps } from './components/NotesModal/NotesModal';
import { SingleRow } from 'features/brazil-grower/components/BrazilGrowerFinance/shared/SingleRow';
import { INotes } from 'shared';

interface NotesSectionProps extends Pick<PhaseSectionProps, 'disabled'>, Pick<NotesModalProps, 'updateCredit'> {
  notesSectionInfo?: INotes;
}

interface NotesSectionSummaryProps extends Pick<NotesSectionProps, 'notesSectionInfo'> {}

export const NotesSectionSummary: React.FunctionComponent<NotesSectionSummaryProps> = ({ notesSectionInfo }) => {
  return notesSectionInfo ? (
    <div className="width-100">
      {notesSectionInfo.creditOpinion ? (
        <SingleRow title={i18next.t('creditOpinion')} content={notesSectionInfo.creditOpinion} />
      ) : null}
      {notesSectionInfo.legalOpinion ? (
        <SingleRow title={i18next.t('legalOpinion')} content={notesSectionInfo.legalOpinion} />
      ) : null}
    </div>
  ) : null;
};

export const NotesSection: React.FunctionComponent<NotesSectionProps> = ({
  notesSectionInfo,
  children,
  updateCredit,
  ...phaseSectionProps
}) => {
  /**
   * State
   */
  const [modalOpen, setModalOpen] = useState(false);

  const openNotesModal = (): void => setModalOpen(true);

  const closeNotesModal = (): void => setModalOpen(false);

  return (
    <>
      <PhaseSection
        {...phaseSectionProps}
        open={!!notesSectionInfo}
        onClickEdit={openNotesModal}
        title={i18next.t('notes')}
        renderSeparatorBefore
      >
        <NotesSectionSummary notesSectionInfo={notesSectionInfo} />
      </PhaseSection>
      <NotesModal
        open={modalOpen}
        closeModal={closeNotesModal}
        notesSectionInfo={notesSectionInfo}
        updateCredit={updateCredit}
      />
    </>
  );
};
